 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {Extension,} from '@tiptap/core'
import {PluginKey} from '@tiptap/pm/state'
import Suggestion from '@tiptap/suggestion'
import renderSuggestion from '../renderSuggestion'
import {SlashCommandMenu} from './SlashCommandMenu'
import {slashCommands,} from './slashCommands'

const extensionName = 'slashCommand'
export const SlashCommand = Extension.create({
  name: extensionName,
  priority: 200,
  addOptions() {
    const commands = slashCommands.flatMap((sc) => sc.commands.map((command) => command.title))
    return commands.reduce(
      (obj, item) => {
        obj[item] = true
        return obj
      },
      {} 
    )
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        char: '/',
        allowSpaces: true,
        startOfLine: true,
        pluginKey: new PluginKey(extensionName),
        allow: ({state, range}) => {
          const $from = state.doc.resolve(range.from)
          const isRootDepth = $from.depth === 1
          const isParagraph = $from.parent.type.name === 'paragraph'
          const isStartOfNode = _optionalChain([$from, 'access', _ => _.parent, 'access', _2 => _2.textContent, 'optionalAccess', _3 => _3.charAt, 'call', _4 => _4(0)]) === '/'
          const isInColumn = this.editor.isActive('column')

          const afterContent = _optionalChain([$from, 'access', _5 => _5.parent, 'access', _6 => _6.textContent, 'optionalAccess', _7 => _7.substring, 'call', _8 => _8(
            _optionalChain([$from, 'access', _9 => _9.parent, 'access', _10 => _10.textContent, 'optionalAccess', _11 => _11.indexOf, 'call', _12 => _12('/')])
          )])
          const isValidAfterContent = !_optionalChain([afterContent, 'optionalAccess', _13 => _13.endsWith, 'call', _14 => _14('  ')])

          return (
            ((isRootDepth && isParagraph && isStartOfNode) ||
              (isInColumn && isParagraph && isStartOfNode)) &&
            isValidAfterContent
          )
        },
        command: ({editor, props}) => {
          const {view, state} = editor
          const {$head, $from} = view.state.selection

          const end = $from.pos
          const from = _optionalChain([$head, 'optionalAccess', _15 => _15.nodeBefore])
            ? end -
              (_nullishCoalesce(_optionalChain([$head, 'access', _16 => _16.nodeBefore, 'access', _17 => _17.text, 'optionalAccess', _18 => _18.substring, 'call', _19 => _19(_optionalChain([$head, 'access', _20 => _20.nodeBefore, 'access', _21 => _21.text, 'optionalAccess', _22 => _22.indexOf, 'call', _23 => _23('/')])), 'access', _24 => _24.length]), () => ( 0)))
            : $from.start()

          const tr = state.tr.deleteRange(from, end)
          view.dispatch(tr)

          props.action(editor)
          view.focus()
        },
        items: ({query}) => {
          return slashCommands
            .map((group) => ({
              ...group,
              commands: group.commands.filter((item) => {
                if (!this.options[item.title]) return false
                const queryNormalized = query.toLowerCase().trim()
                const isQueryInTerm = item.searchTerms.some((searchTerm) =>
                  searchTerm.includes(queryNormalized)
                )
                if (!isQueryInTerm) return false
                const {shouldHide} = item 
                return shouldHide ? !shouldHide(this.editor) : true
              })
            }))
            .filter((group) => group.commands.length > 0)
        },
        render: renderSuggestion(SlashCommandMenu)
      })
    ]
  }
})
